/**
 * Core Layer - Canvas Utilities
 * Low-level canvas drawing operations
 * No state management, no business logic - pure functions only
 */

export class CanvasUtils {
    /**
     * Draw an arrow on canvas
     */
    static arrow(ctx, x, y, color, isTwoLetters, isReversed) {
        const decrease = (x, y) => isReversed ? x + y : x - y;
        const increase = (x, y) => isReversed ? x - y : x + y;
        const xMax = isTwoLetters ? 10 : 8;
        const xMin = isTwoLetters ? 6 : 4;

        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.moveTo(decrease(x, 8), decrease(y, 12));
        ctx.lineTo(decrease(x, xMin), decrease(y, 12));
        ctx.lineTo(decrease(x, xMin), decrease(y, 30));
        ctx.lineTo(x, decrease(y, 25));
        ctx.lineTo(increase(x, xMin), decrease(y, 30));
        ctx.lineTo(increase(x, xMin), decrease(y, 12));
        ctx.lineTo(increase(x, xMax), decrease(y, 12));
        ctx.lineTo(x, y);
        ctx.fill();
    }

    /**
     * Draw text on canvas
     */
    static text(ctx, text, x, y, color) {
        const width = ctx.canvas.width;
        ctx.strokeStyle = color;
        ctx.font = "8px Arial";
        ctx.save();
        ctx.translate(width, 0);
        ctx.scale(-1, 1);
        ctx.strokeText(text, width - x - (text.length > 1 ? 5 : 2), y - 15);
        ctx.restore();
    }

    /**
     * Draw circle (beacon) on canvas
     */
    static circle(ctx, x, y, color) {
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.ellipse(x, y, 10, 7, 0, 0, 2 * Math.PI);
        ctx.stroke();
    }

    /**
     * Draw a line between two points
     */
    static drawLine(ctx, fromX, fromY, toX, toY, color, lineWidth = 1) {
        ctx.strokeStyle = color;
        ctx.lineWidth = lineWidth;
        ctx.beginPath();
        ctx.moveTo(fromX, fromY);
        ctx.lineTo(toX, toY);
        ctx.stroke();
    }

    /**
     * Clear entire canvas
     */
    static clearCanvas(ctx) {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    }

    /**
     * Get canvas image data
     */
    static getImageData(ctx) {
        return ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
    }

    /**
     * Put image data on canvas
     */
    static putImageData(ctx, imageData, x = 0, y = 0) {
        ctx.putImageData(imageData, x, y);
    }

    /**
     * Draw image on canvas
     */
    static drawImage(ctx, image, x, y, width, height) {
        ctx.drawImage(image, x, y, width, height);
    }
}
